<template>
    <div>
        <div class="title" ref="title">
            <transition name="text" appear>
                <div class="textArea">
                    爆震技术
                </div>
            </transition>
        </div>
        <div class="knockingVideo" ref="video">
            <div class="text">
                <div class="text-wrapper" v-if="textShow" style="white-space: pre-line;">
                    <span v-for="(char, index) in text" :key="index"
                        :style="{ 'animation-delay': `${1 + index * 0.05}s` }">
                        {{ char }}
                    </span>
                </div>
            </div>
            <div class="line" v-if="textShow"></div>
            <div class="circle" v-if="textShow"></div>
            <div class="video">
                <video autoplay muted loop class="background-video">
                    <source :src="require('@/assets/knocking/backVideo.mp4')" type="video/mp4" />
                    Your browser does not support the video tag.
                </video>

            </div>
        </div>


    </div>

</template>

<script>
import videoBackground from '../common/videoBackground.vue';
export default {
    components: { videoBackground },
    data() {
        return {
            textShow: false,
            text: '爆震燃烧是一种特殊的超声速燃烧过程。\n\n在这个过程中，燃料与氧化剂的混合物在超声速燃烧波的引导下，通过急剧的压缩和化学反应完成燃烧。其显著特点是燃烧波的传播速度超过声速，瞬时释放能量，产生高温、高压，从而提高热效率。\n\n爆震燃烧技术是基于爆震燃烧原理开发出的实际应用技术，旨在利用爆震燃烧的特点提高推进系统、发电系统或其他能量转换系统的性能。',
            lineShow: false
        }
    },

    mounted() {
        window.scrollTo({
            top: 0,
            behavior: 'smooth'
        })
        setTimeout(() => {
            window.addEventListener('scroll', this.handleScroll);
        }, 1000);

    },
    methods: {
        handleScroll() {
            if (this.textShow === false) {
                if (this.$refs.video) {
                    this.textShow = document.documentElement.scrollTop > this.$refs.video.getBoundingClientRect().top;
                }
            }
        }
    },

}
</script>

<style lang="scss" scoped>
.title {
    height: 100vh;
    width: 100%;
    background-image: url('../../assets/knocking/页面3-1图片.jpg');
    background-repeat: no-repeat;
    background-size: cover;

    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;

    .textArea {
        height: 20%;
        width: 100%;
        background-color: rgb(76, 76, 226, 0.5);
        display: flex;
        flex-direction: row;
        justify-content: center;
        align-items: center;
        font-family: QHKT;
        font-weight: bold;
        font-size: 50px;
        color: white;
    }
}

.knockingVideo {
    width: 100%;
    height: 100vh;
    display: flex;
    flex-direction: row;
    position: relative;

    .text {
        height: 100%;
        width: 40%;
        background-color: black;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
    }

    .line {
      position: absolute;
      top: 35%;
      right: 40%;
      width: 0;
      height: 10%;
      animation: growLine 1s forwards;
      border-left: 1px solid transparent;
      border-right: 2px solid rgb(88, 94, 94);
      border-top: 2px solid rgb(88, 94, 94);
      transform: skew(35deg);
      z-index: 999;
    }

    .circle{
        position: absolute;
        top: 44.5%;
        right: 37.7%;
        width: 2vh;
        height: 2vh;
        // border: 3px solid;
        background-color: rgb(88, 94, 94);
        border-radius: 2vh;
        z-index: 999;
    }


    .video {
        width: 60%;
        position: relative;
        background-color: black;

        .background-video {
            position: absolute;
            top: 50%;
            left: 50%;
            width: 50%;
            height: 50%;
            /* object-fit: cover; */
            /* 确保视频覆盖整个背景 */
            transform: translate(-50%, -50%);
            z-index: 1;
            /* 视频置于底层 */
        }
    }

    .text-wrapper {
        display: inline-block;
        width: 80%;
        height: 46%;
        // transform: translateY(-10%);
        font-family: QHKT;
        font-size: 26px;
        letter-spacing: 1px;
        color: white;
        animation: borderShow 3s forwards;
        padding: 5%;

    }

    .text-wrapper span {
        opacity: 0;
        animation: fadeIn .5s forwards;
    }
}

// .text-enter-active {
//     animation: bounce-in 2s;
// }

// .text-enter {
//     opacity: 0;
// }

// @keyframes bounce-in {
//     0% {
//         transform: scale(0);
//     }

//     100% {
//         transform: scale(1);
//     }
// }
.text-enter-active {
    transition: all 2s;
}

.text-enter {
    opacity: 0;
    transform: translateY(-50px);
}



@keyframes fadeIn {
    to {
        opacity: 1;
    }
}

@keyframes borderShow {
    to {
        border: 1px solid;
        border-radius: 20px;
        border-color: rgb(101, 112, 112);
    }
}

@keyframes growLine {
    from {
        width: 0;
    }

    /* 开始时宽度为0 */
    to {
        width: 20.1%;
    }

    /* 结束时宽度为100% */
}
</style>